import { cl } from '../../common/functions';
import { variables } from '../../common/variables';
let map;
let markersCluster;
if (variables.shortcodeTypeValue !== null) {
  if (document.getElementById("map") !== null) {
    // leaflet map init
    map = L.map("map", {
      gestureHandling: true,
      minZoom: 9
    });
    let osmUrl = "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png";
    let osmAttrib = "Map data © OpenStreetMap contributors";
    let osm = new L.TileLayer(osmUrl, { attribution: osmAttrib });
    map.addLayer(osm);

    // fullscreen
    map.addControl(new L.Control.Fullscreen());

    //Cluster de markers
    markersCluster = L.markerClusterGroup({
      maxClusterRadius: 40,
      iconCreateFunction: cluster => {
        return L.divIcon({
          iconSize: [40, 40],
          iconAnchor: [20, 40],
          className: 'cluster',
          html: /* html */ `
            <div id="leaflet-marker-icon__${Math.floor(Math.random() * 30) + 1}">
              <svg class="marker-cluster">
                <use xlink:href="${variables.parentThemePath}/assets/img/markers/marker-cluster.svg#marker-cluster" tabindex="0"></use>
              </svg>
              <div class="cluster__child-count">${cluster.getChildCount()}</div>
              <div class="pulse"></div>
            </div>
          `,
          popupAnchor: [0, -40]
        });
      }
    });

    if (variables.shortcodeTemplateValue === 'full') {
      let shortcodeSearchLanguageValue = '';
      if (variables.shortcodeSearchLanguageValue.length !== 0) {
        shortcodeSearchLanguageValue = `${variables.shortcodeSearchLanguageValue}'`;
      }
      let shortcodeSearchCountryValue = '';
      if (variables.shortcodeSearchCountryValue.length !== 0) {
        shortcodeSearchCountryValue = `${variables.shortcodeSearchCountryValue}`;
      }
      if (variables.shortcodeSearchTypeValue !== 'custom') {
        //Search-control
        const searchControl = new GeoSearch.SearchControl({
          style: 'bar',
          showMarker: false,
          showPopup: false,
          searchLabel: 'Rechercher une ville...',
          notFoundMessage: 'Aucun résultat trouvé',
          zoomLevel: 11,
          animateZoom: true,
          autoClose: true,
          keepResult: true,
          maxSuggestions: 4,
          provider: new GeoSearch.OpenStreetMapProvider({
            params: {
              'accept-language': shortcodeSearchLanguageValue,
              countrycodes: shortcodeSearchCountryValue,
              addressdetails: 0
            }
          })
        });
        map.addControl(searchControl);
      }
    }
  }

}
export { map, markersCluster };
